document.addEventListener("shown.bs.modal", (event) => {
  if (event.target.id === "employee-pin-login-modal") {
    const pinInput = event.target.querySelector("#employee_pin_login_pin");
    pinInput.focus();
  }
});
